import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslationSandbox } from '@app/translation/sandboxes/translation.sandbox';
import { environment } from '@environments/environment';
import { Language } from '@smooved/core';
import { SvgIllustration } from '@ui/svg';
import { map, Observable } from 'rxjs';
import { MoveSandbox } from '../../../move/sandboxes/move.sandbox';
import { ServiceType } from '@app/services/types/service-type';
import { PosthogServicesService } from '@app/tracking/posthog-services.service';

@Component({
    selector: 'app-minor-service-list',
    template: `
        <div class="u-flex-column">
            <p *ngIf="showText" class="u-color-muted u-margin-bottom">{{ 'DASHBOARD.MINOR_SERVICE_LIST.TITLE' | translate }}</p>
            <app-minor-service
                (click)="posthogServicesService.clickService(serviceType.SmoovedDeals)"
                [title]="'DASHBOARD.SMOOVED_DEALS.TITLE' | translate"
                [href]="marketplaceLink$ | async"
                [illustration]="svgIllustration.MarketPlaceIcon"
            ></app-minor-service>
            <app-logistics (click)="posthogServicesService.clickService(serviceType.Logistics)"></app-logistics>
            <app-post (click)="posthogServicesService.clickService(serviceType.Post)" [last]="true"></app-post>
        </div>
    `,
    styleUrls: ['./minor-service-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MinorServiceListComponent {
    @Input() public showText = true;

    public readonly serviceType = ServiceType;

    public readonly svgIllustration = SvgIllustration;
    public marketplaceLink$: Observable<string> = this.translationSandbox.selected$.pipe(
        map((lang) => environment.marketplace[lang || Language.NL])
    );

    constructor(
        public readonly moveSandbox: MoveSandbox,
        private readonly translationSandbox: TranslationSandbox,
        public readonly posthogServicesService: PosthogServicesService
    ) {}
}
